<div class="ds-dialog window-drag-handle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div class="ds-header-dialog">
    <h3>{{ 'VIDEO_CALL' | translate }}</h3>
    <div class="ds-flex">
      <mat-icon (click)="close()" svgIcon="close-l" style="cursor: pointer" class="ml-16"></mat-icon>
    </div>
  </div>
  <div>
    <div class="jitsi-toolbox-content">
      <app-avatar [url]="avatarUrl" [size]="'128'" [setIconSize]="true"></app-avatar>
      <p class="incoming-call-text">{{ name + ' está te ligando' }}</p>
    </div>
    <div class="jitsi-toolbox-content-items">
      <div class="jitsi-toolbox-icon jitsi-hangup-menu-button" (click)="close()">
        <mat-icon [svgIcon]="'jitsi-hangup'"></mat-icon>
      </div>
      <div class="jitsi-toolbox-icon jitsi-answer-menu-button" (click)="answer()">
        <mat-icon [svgIcon]="'jitsi-video'"></mat-icon>
      </div>
    </div>
  </div>
</div>
